<div class="flex flex-row flex-wrap items-center justify-start gap-1" [class.editor-rule-disabled]="!term.enabled">
  <!-- PaymentTermsAfterAccepted -->
  <ng-container *ngIf="term.type === CancellationTermType.PaymentTermsAfterAccepted">
    <div class="dropdown-select percent" [matMenuTriggerFor]="percentMenu">{{ term.percentage }}%</div>
    <div>due at booking</div>
  </ng-container>

  <!-- PaymentTermsBeforeCheckin -->
  <ng-container *ngIf="term.type === CancellationTermType.PaymentTermsBeforeCheckin">
    <div class="dropdown-select percent" #percentTrigger="matMenuTrigger" [matMenuTriggerFor]="percentMenu">
      {{ term.percentage }}%
    </div>
    <div>due</div>
    <div class="dropdown-select duration" [matMenuTriggerFor]="timingOptionsMenu">
      {{ term.trigger_time.amount }} {{ term.trigger_time.units }}
    </div>

    <div>before check-in</div>
  </ng-container>

  <!-- AfterBooking -->
  <ng-container *ngIf="term.type === CancellationTermType.AfterBooking">
    <div>
      <mat-slide-toggle [(ngModel)]="term.enabled"></mat-slide-toggle>
    </div>

    <div class="dropdown-select percent" #percentTrigger="matMenuTrigger" [matMenuTriggerFor]="percentMenu">
      {{ term.percentage }}%
    </div>
    <div>refund</div>

    <div class="dropdown-select duration" [matMenuTriggerFor]="limitedTimingOptionsMenu">
      {{ term.trigger_time.amount }} {{ term.trigger_time.units }}
    </div>

    <div>after booking accepted, if booking is requested at least</div>
    <div class="dropdown-select duration" [matMenuTriggerFor]="afterBookingBufferMenu">
      {{ term.days_before_checkin_restriction?.amount }} {{ term.days_before_checkin_restriction?.units }}
    </div>
    <div>before check-in</div>

    <mat-menu #afterBookingBufferMenu="matMenu">
      <div class="before-checkin-menu" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-form-field class="nopadding short-number-input">
          <input
            autofocus
            matInput
            type="number"
            min="0"
            max="100"
            pattern="^(100|[1-9]?\d(\.\d\d?)?)$"
            [(ngModel)]="term.days_before_checkin_restriction.amount"
            (click)="$event.preventDefault(); $event.stopPropagation()" />
        </mat-form-field>

        <div>days</div>
      </div>
    </mat-menu>
  </ng-container>

  <!-- BeforeCheckIn -->
  <ng-container *ngIf="term.type === CancellationTermType.BeforeCheckIn">
    <div>
      <mat-slide-toggle [(ngModel)]="term.enabled"></mat-slide-toggle>
    </div>

    <div class="dropdown-select percent" #percentTrigger="matMenuTrigger" [matMenuTriggerFor]="percentMenu">
      {{ term.percentage }}%
    </div>
    <div>refund</div>
    <div class="dropdown-select duration" [matMenuTriggerFor]="timingOptionsMenu">
      {{ term.trigger_time.amount }} {{ term.trigger_time.units }}
    </div>
    <div>before check-in</div>
  </ng-container>
</div>

<mat-menu #percentMenu="matMenu">
  <mat-form-field class="fw nopadding percent-input">
    <input
      autofocus
      matInput
      type="number"
      min="0"
      max="100"
      placeholder="0 - 100"
      pattern="^(100|[1-9]?\d(\.\d\d?)?)$"
      [value]="term.percentage"
      (click)="$event.preventDefault(); $event.stopPropagation()"
      (input)="validatePercent($event)"
      (keyup.enter)="percentTrigger.closeMenu()" />
    <span matSuffix>%</span>
  </mat-form-field>
</mat-menu>

<mat-menu #timingOptionsMenu="matMenu">
  <div class="before-checkin-menu" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <mat-form-field class="nopadding short-number-input">
      <input
        autofocus
        matInput
        type="number"
        min="0"
        max="100"
        placeholder="0 - 100"
        pattern="^(100|[1-9]?\d(\.\d\d?)?)$"
        [(ngModel)]="term.trigger_time.amount"
        (click)="$event.preventDefault(); $event.stopPropagation()" />
    </mat-form-field>

    <mat-form-field class="nopadding">
      <mat-select [(ngModel)]="term.trigger_time.units">
        <mat-option value="hours">hours</mat-option>
        <mat-option value="days">days</mat-option>
        <mat-option value="weeks">weeks</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-menu>

<mat-menu #limitedTimingOptionsMenu="matMenu">
  <button mat-menu-item (click)="term.trigger_time = { amount: 24, units: 'hours' }">24 hours</button>
  <button mat-menu-item (click)="term.trigger_time = { amount: 48, units: 'hours' }">48 hours</button>
</mat-menu>
